<app-menu 
urlGitHub="https://github.com/EdimilsonBorges/" 
urlLinkedin="https://www.linkedin.com/in/edimilson-borges/" 
urlInstagran="https://www.instagram.com/edimilson_borgess/"
></app-menu>
<router-outlet></router-outlet>
<app-footer></app-footer>
